"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFileMetadataSchema = void 0;
const tslib_1 = require("tslib");
const fluent_json_schema_1 = tslib_1.__importDefault(require("fluent-json-schema"));
const buildFileMetadataSchema = (fileMetadataSchema) => {
    let objectSchema = fluent_json_schema_1.default.object();
    for (const prop of Object.keys(fileMetadataSchema)) {
        const schema = fileMetadataSchema[prop];
        objectSchema = objectSchema.prop(prop, schema);
    }
    return {
        prop: "metadata",
        schema: objectSchema,
    };
};
exports.buildFileMetadataSchema = buildFileMetadataSchema;
//# sourceMappingURL=buildFileMetadataSchema.js.map